import React, { createContext, useContext, useState } from "react";

const EnquiryContext = createContext({ open: () => {}, isOpen: false });

export const EnquiryProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  return (
    <EnquiryContext.Provider value={{ isOpen, open, close }}>
      {children}
    </EnquiryContext.Provider>
  );
};

export const useEnquiry = () => useContext(EnquiryContext);
